/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ApiToken } from "./ApiToken";
export const ApiTokenResponse = core.serialization.object({
    data: ApiToken,
});
